module.exports = __webpack_public_path__ + "img/sprite.3d806d7c.svg";